module.exports = "/images/EUDMLlogo.png?a0c985702c3aaeaeba13c5b8fb22c866";